// src/pages/Home.jsx
import Layout from "../layouts/Layout"; // Import Layout component

import HeroSection from "../components/HeroSection";
import BrandSection from "../components/BrandSection";
import AboutSection from "../components/AboutSection";
import ServiceSection from "../components/ServiceSection";
import PortfolioSection from "../components/PortfolioSection";
import TeamSection from "../components/TeamSection";
import TestimonialSection from "../components/TestimonialSection";
import NewsSection from "../components/NewsSection";

const Home = () => (
  <Layout>
    <HeroSection />
    <BrandSection />
    <AboutSection />
    <ServiceSection />
    <PortfolioSection />
    <TeamSection />
    <TestimonialSection />
    <NewsSection />
  </Layout>
);

export default Home;
